/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Select_DatesInputs */

const en_rental_select_dates = /** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Your Dates`)
};

const es_rental_select_dates = /** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona Tus Fechas`)
};

const fr_rental_select_dates = /** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez vos dates`)
};

const de_rental_select_dates = /** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle deine Daten`)
};

const id_rental_select_dates = /** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih Tanggal Anda`)
};

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const ja_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const zh_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const ar_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const it_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const ru_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const pt_rental_select_dates = en_rental_select_dates;

/** @type {(inputs: Rental_Select_DatesInputs) => LocalizedString} */
const ko_rental_select_dates = en_rental_select_dates;

/**
* | output |
* | --- |
* | "Select Your Dates" |
*
* @param {Rental_Select_DatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_select_dates = /** @type {((inputs?: Rental_Select_DatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Select_DatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_select_dates(inputs)
	if (locale === "es") return es_rental_select_dates(inputs)
	if (locale === "fr") return fr_rental_select_dates(inputs)
	if (locale === "de") return de_rental_select_dates(inputs)
	if (locale === "ja") return ja_rental_select_dates(inputs)
	if (locale === "zh") return zh_rental_select_dates(inputs)
	if (locale === "ar") return ar_rental_select_dates(inputs)
	if (locale === "id") return id_rental_select_dates(inputs)
	if (locale === "it") return it_rental_select_dates(inputs)
	if (locale === "ru") return ru_rental_select_dates(inputs)
	if (locale === "pt") return pt_rental_select_dates(inputs)
	return ko_rental_select_dates(inputs)
});